import React from "react";

const LocationIcon = ({ width = 32, height = 32, stroke = "#00D68F", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.6667 13.3333C26.6667 19.9906 19.2814 26.924 16.8014 29.0653C16.5703 29.239 
        16.2891 29.333 16 29.333C15.711 29.333 15.4297 29.239 15.1987 29.0653C12.7187 26.924 
        5.33337 19.9906 5.33337 13.3333C5.33337 10.5043 6.45718 7.79121 8.45757 5.79082C10.458 
        3.79043 13.1711 2.66663 16 2.66663C18.829 2.66663 21.5421 3.79043 23.5425 5.79082C25.5429 
        7.79121 26.6667 10.5043 26.6667 13.3333Z"
        stroke={stroke}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17.3334C18.2091 17.3334 20 15.5425 20 13.3334C20 11.1242 18.2091 9.33337 
        16 9.33337C13.7909 9.33337 12 11.1242 12 13.3334C12 15.5425 13.7909 17.3334 16 17.3334Z"
        stroke={stroke}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LocationIcon;
